import {AfriexAdminPermission} from '@afriex/core/domain/enums';

import {PermissionsProvider} from '@/components';
import type {AfriexQueryParams} from '@/types';

import FeeUpdateButton from './FeeUpdateButton';

export type BusinessFeesFiltersProps = {
  currentFilters: AfriexQueryParams;
  clearFilters?: () => void;
  selectCurrentFilters: (
    name: string,
    value: string | Date | undefined,
  ) => void;
  handleAutoComplete: (search: string) => void;
  businessId?: string;
  businessName?: string;
  /** Test hook prefix for the create action; forwarded to the button. */
  dataCy?: string;
  /** Test hook prefix for the create form the button opens. */
  formDataCy?: string;
  /** Called after a fee is created so the list can refresh in place. */
  onFeeSaved?: () => void | Promise<void>;
};

const BusinessFeesFilters: React.FC<BusinessFeesFiltersProps> = ({
  businessId,
  businessName,
  dataCy,
  formDataCy,
  onFeeSaved,
}) => {
  return (
    <div className="flex md:justify-end">
      {/* Status Select Box */}
      <PermissionsProvider permission={AfriexAdminPermission.BusinessFeeManage}>
        <FeeUpdateButton
          dataCy={dataCy}
          formDataCy={formDataCy}
          businessId={businessId}
          businessName={businessName}
          onSuccess={onFeeSaved}
        />
      </PermissionsProvider>
    </div>
  );
};

export default BusinessFeesFilters;
